import React, {
  PropsWithChildren,
  ReactElement,
  SubmitEventHandler,
} from 'react';
import { SceneNavigation } from '../scene-navigation/scene-navigation.component';

export interface SceneFormProps extends PropsWithChildren {
  onSubmit: SubmitEventHandler<HTMLFormElement>;
  id: string;
}

export const SceneForm = ({
  onSubmit,
  id,
  children,
}: SceneFormProps): ReactElement => (
  <form
    id={id}
    data-testid={id}
    onSubmit={onSubmit}
    className={'flex flex-col items-center gap-y-8'}
    noValidate={true} // handled by react-hook-form
  >
    <div className={'flex w-full flex-col gap-y-6'}>{children}</div>
  </form>
);

export interface SceneFormWithNavigationProps extends PropsWithChildren {
  onSubmit: SubmitEventHandler<HTMLFormElement>;
  onPrev: () => void;
  formId: string;
}

export const SceneFormWithNavigation = ({
  onSubmit,
  onPrev,
  formId,
  children,
}: SceneFormWithNavigationProps): ReactElement => (
  <div
    className={'pt-6 tablet:pb-0 desktop:p-0 desktop:pt-10'}
    style={{
      height: 'calc(100% + env(safe-area-inset-bottom))',
      paddingBottom: 'env(safe-area-inset-bottom)',
    }}
  >
    <SceneForm onSubmit={onSubmit} id={formId}>
      {children}
    </SceneForm>
    <SceneNavigation onPrev={onPrev} id={formId} />
  </div>
);
